var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"List",style:({ gridTemplateColumns: _vm.gridColumns,gap:_vm.intervalPx })},[_vm._t("Item")],2)}
var staticRenderFns = []

export { render, staticRenderFns }